/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaListDialogSaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaListDialogSaveAction({
  children,
  viewPath = "/DesignSystem/TysiaListDialog/TysiaListDialogSaveAction",
  disabled,
  onSubmit,
  text = "Save"
  
}) {
let listDialogSubmitData = fromData.useDataSubmit({ viewPath,
context: 'list_dialog',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="primary"
 disabled={disabled}
 data="list_dialog"
 onClick={listDialogSubmitData}
 stopPropagation={true}
 marginLeft={dtSpaceXs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={text}
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}